import React from 'react';

import { Input } from '../../../../../../components/Input/index';
import { RadioButton } from '../../../../../../components/RadioButton/index';
import { i18nMark } from 'lingui-react';

import './contactInfoCard.css';

export const ContactInfoCard = (props) => {
  return ([
    <div className="company-contact-info-card" key="1">
      <div className={props.validationMessages[props.name + '.assigned'] ? "container no-padding error" : "container no-padding"}>
        <div className='title-input  row'>
          <div className="col-sm-12 col-md-7">
            <p>{props.requiredMark ? <span>* </span> : ''}{props.titleCard}</p>
          </div>
          {!props.requiredCard ? (
            <div className="col-sm-12 col-md-5 d-flex justify-content-lg-end">
              <RadioButton key="rdoYes" name={props.name} className="yes" id={props.name + '_yes'} text={props.i18n._(i18nMark('Yes'))} onSelect={props.onSelectCard}
                selected={props.hasRole === 'yes'} value="yes" />
              <RadioButton key="rdoNo" name={props.name} className="no" id={props.name + '_no'} text={props.i18n._(i18nMark('No'))} onSelect={props.onSelectCard}
                selected={props.hasRole === 'no'} value="no" />
            </div>
          ) : null}
        </div>
      </div>
      <div className="container">
        <div className={props.hasRole === 'yes' || props.requiredCard ? 'row' : 'row hide-element'}>
          <div className="col-12">
            <div className="content-input">
              <Input
                labelName={props.i18n._(i18nMark('* First Name'))}
                inputStyle="input-card"
                labelStyle="label-input-company"
                placeHolder={props.i18n._(i18nMark('First Name'))}
                validationMessages={props.validationMessages[props.name + '.firstName']}
                type="text"
                name={props.name + '_firstName'}
                value={props.contactInfoMember.firstName}
                onChange={props.onInputChange}
                id={props.name + '_firstName'}
              />
              <Input
                labelName={props.i18n._(i18nMark('* Last Name'))}
                inputStyle="input-card"
                labelStyle="label-input-company"
                placeHolder={props.i18n._(i18nMark('Last Name'))}
                validationMessages={props.validationMessages[props.name + '.lastName']}
                type="text"
                name={props.name + '_lastName'}
                value={props.contactInfoMember.lastName}
                onChange={props.onInputChange}
                id={props.name + '_lastName'}
              />
              <Input
                labelName={props.i18n._(i18nMark('Phone Number'))}
                inputStyle="input-card"
                labelStyle="label-input-company"
                placeHolder={props.i18n._(i18nMark('Phone Number'))}
                validationMessages={props.validationMessages[props.name + '.phoneNumber']}
                name={props.name + '_phoneNumber'}
                type="text"
                value={props.contactInfoMember.phoneNumber}
                onChange={props.onInputChange}
                id={props.name + '_phoneNumber'}
              />
              <Input
                labelName={props.i18n._(i18nMark('Email'))}
                inputStyle="input-card"
                labelStyle="label-input-company"
                placeHolder={props.i18n._(i18nMark('Email'))}
                validationMessages={props.validationMessages[props.name + '.email']}
                name={props.name + '_email'}
                type="text"
                value={props.contactInfoMember.email}
                onChange={props.onInputChange}
                id={props.name + '_email'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>,
  ]);
};



// WEBPACK FOOTER //
// ./src/screens/Company/components/ContactInfo/components/ContactInfoCard/ContactInfoCard.js